module.exports = "/images/pergamum.svg?a30dac48328d07f09ab3e1b6c9ee1a11";